// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderApprovalSuccess_container__hF9yx {
  padding: 2rem;
  animation: OrderApprovalSuccess_init__8d6S9 0.5s;
}

.OrderApprovalSuccess_header__9f3le {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 2rem;
}

.OrderApprovalSuccess_successCard__2eBoI {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid #4caf50;
}

.OrderApprovalSuccess_loader__NJ98i {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;
  min-height: 400px;
}

@keyframes OrderApprovalSuccess_init__8d6S9 {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Pages/AgencyOrders/Backoffice/OrderApprovalSuccess/OrderApprovalSuccess.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gDAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  padding: 2rem;\n  animation: init 0.5s;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.successCard {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border: 2px solid #4caf50;\n}\n\n.loader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 4rem;\n  min-height: 400px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OrderApprovalSuccess_container__hF9yx`,
	"init": `OrderApprovalSuccess_init__8d6S9`,
	"header": `OrderApprovalSuccess_header__9f3le`,
	"successCard": `OrderApprovalSuccess_successCard__2eBoI`,
	"loader": `OrderApprovalSuccess_loader__NJ98i`
};
export default ___CSS_LOADER_EXPORT___;
